import * as Sentry from "@sentry/react";
import React, { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon, FontAwesomeIcons } from "src/constants/fontAwesomeIcons";
const ToggleFeedbackButton: React.FunctionComponent = () => {
  const [feedback, _setFeedback] = useState(() => Sentry.getFeedback());
  const buttonRef = useRef<HTMLAnchorElement>(null);
  useEffect(() => {
    if (buttonRef.current) {
      const unsubscribe = feedback?.attachTo(buttonRef.current, {});
      return () => {
        unsubscribe?.();
      };
    }
  }, [buttonRef]);
  return <button color="inherit" ref={(buttonRef as any)} className="btn btn-primary" data-tip="Report a Bug" data-sentry-component="ToggleFeedbackButton" data-sentry-source-file="ToggleFeedbackButton.tsx">
            <FontAwesomeIcon icon={FontAwesomeIcons.Regular.MEGAPHONE} fixedWidth data-sentry-element="FontAwesomeIcon" data-sentry-source-file="ToggleFeedbackButton.tsx" />
        </button>;
};
export default ToggleFeedbackButton;